export interface Category {
  name: string;
  url: string;
  icon: string;
  imageSrc: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20fashion%20sneakers%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20background%2C%20premium%20footwear%20presentation%2C%20editorial%20style&width=200&height=200&seq=cat-shoes&orientation=squarish',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Stylish%20cozy%20hoodie%20folded%20neatly%20on%20a%20soft%20beige%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20fashion%20photography%2C%20clean%20aesthetic%2C%20neutral%20cream%20tones%2C%20modern%20apparel%20presentation&width=200&height=200&seq=cat-hoodies&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20neatly%20folded%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimalist%20clothing%20photography%2C%20clean%20simple%20aesthetic%2C%20neutral%20beige%20tones%2C%20modern%20fashion%20presentation&width=200&height=200&seq=cat-tshirts&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20jacket%20displayed%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20fashion%20photography%2C%20warm%20beige%20tones%2C%20editorial%20product%20presentation%2C%20contemporary%20outerwear%20aesthetic&width=200&height=200&seq=cat-jackets&orientation=squarish',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-layout-grid-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Well-tailored%20casual%20pants%20neatly%20folded%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20clothing%20photography%2C%20clean%20neutral%20aesthetic%2C%20modern%20apparel%20presentation%2C%20simple%20background&width=200&height=200&seq=cat-pants&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-smile-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20and%20beanie%20accessories%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20light%2C%20minimalist%20fashion%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20aesthetic%2C%20modern%20headwear%20presentation&width=200&height=200&seq=cat-headwear&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20clothing%20set%20displayed%20on%20a%20soft%20beige%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20fashion%20photography%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20modern%20apparel%20styling&width=200&height=200&seq=cat-sets&orientation=squarish',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20basics%20neatly%20arranged%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20clean%20aesthetic%2C%20modern%20essentials%20presentation&width=200&height=200&seq=cat-underwear&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20sportswear%20photography%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic%2C%20modern%20athletic%20apparel%20presentation&width=200&height=200&seq=cat-jersey&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20fashion%20accessories%20including%20sunglasses%20and%20watch%20on%20a%20soft%20beige%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20tones%2C%20elegant%20presentation&width=200&height=200&seq=cat-accessories&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20minimalist%20fashion%20accessory%20photography%2C%20warm%20beige%20tones%2C%20clean%20aesthetic%2C%20premium%20product%20presentation&width=200&height=200&seq=cat-bags&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSrc: 'https://readdy.ai/api/search-image?query=Stylish%20leather%20belt%20elegantly%20displayed%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20fashion%20accessory%20photography%2C%20clean%20aesthetic%2C%20neutral%20beige%20tones%2C%20refined%20product%20presentation&width=200&height=200&seq=cat-belts&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20on%20a%20clean%20cream%20surface%20with%20soft%20shadows%2C%20warm%20natural%20light%2C%20minimalist%20fragrance%20product%20photography%2C%20neutral%20beige%20tones%2C%20sophisticated%20aesthetic%2C%20refined%20presentation&width=200&height=200&seq=cat-perfumes&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSrc: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20and%20fashion%20miscellaneous%20items%20neatly%20arranged%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20daylight%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20tones%2C%20organized%20variety%20presentation&width=200&height=200&seq=cat-other&orientation=squarish',
  },
];